import { Checkbox } from '@components/Filters/Filter/components/FilterContent/TagsFilter/Checkbox/Checkbox';
import { Text } from '@components/index';
import { DocumentAddedBy } from '@models/Document.model';
import { PartialSetter } from '@pages/Products/Heading.types';
import { GetDocumentsByStudioFilter } from '@services/queries/documents/getDocumentsByStudio/getDocumentsByStudio.types';
import { getManufacturersNames } from '@services/queries/manufacturers';
import { updateDocumentsFilterManufactorNames } from '@store/redux/features/filter';
import { useAppDispatch, useAppSelector } from '@store/redux/store';
import React, { useRef, useState } from 'react';
import { useMutation } from 'react-query';
import { SourceLabel } from '../../logic/SourceLabel';
import {
  SearchBarManufacturer,
  SearchBarManufacturerCallbacks,
} from '../SearchBarManufacturer';
import {
  CheckboxList,
  CheckboxWrapper,
  GroupSource,
  SourceList,
  StyledDiv,
} from './SourceFilter.styles';

interface SourceFilterProps {
  broadcast: PartialSetter<GetDocumentsByStudioFilter>;
  filter: GetDocumentsByStudioFilter;
}
export function SourceFilter(props: SourceFilterProps) {
  const { broadcast, filter } = props;
  const [data, setData] = useState<string[]>([]);
  const callbackRef = useRef<null | SearchBarManufacturerCallbacks>(null);

  const mutationGetManufactorsNames = useMutation(getManufacturersNames, {
    onSuccess: result => {
      // Todo: actually wire up onSuccess
      callbackRef.current?.onSuccess();
      setData(result.map(item => item.name));
    },
  });
  const dispatch = useAppDispatch();
  const {
    filter: { documentOptions },
  } = useAppSelector();

  const { manufacturerId = [] } = filter;

  // Todo: Use active param internally to avoid these checks and keep single source of truth
  const onValueChange = (newManufacturer: string): void => {
    const filterExist = manufacturerId.find(item => item === newManufacturer);
    let newManufacturerId = manufacturerId;

    const storeExist = documentOptions.manufactorNames.find(item => {
      return item === newManufacturer;
    });
    if (!filterExist) {
      newManufacturerId = manufacturerId.concat(newManufacturer);
      broadcast({
        manufacturerId: newManufacturerId,
      });
    }
    if (!storeExist) {
      newManufacturerId =
        documentOptions.manufactorNames.concat(newManufacturer);
      dispatch(updateDocumentsFilterManufactorNames(newManufacturerId));
    }
    console.log({ manufacturerId, newManufacturerId });
  };

  function onCheck(e: React.ChangeEvent<HTMLInputElement>) {
    const { checked, value } = e.currentTarget;
    const hasManufacturer = manufacturerId.includes(value);
    if (checked && !hasManufacturer) {
      const newNames = manufacturerId.concat(value);
      broadcast({ manufacturerId: newNames });
    }
    if (!checked && hasManufacturer) {
      const newNames = manufacturerId.filter(_name => {
        return _name !== value;
      });
      broadcast({ manufacturerId: newNames });
    }
  }
  function onStatusCheck(e: React.ChangeEvent<HTMLInputElement>) {
    const { checked } = e.currentTarget;
    if (checked) {
      broadcast({ source: DocumentAddedBy.internal });
    } else {
      broadcast({ source: undefined });
    }
  }
  const sourceCheckId = `show-source-${DocumentAddedBy.internal}`;
  return (
    <StyledDiv>
      <SearchBarManufacturer
        data={data}
        onDataChange={setData}
        startSearch={mutationGetManufactorsNames.mutate}
        onValueChange={onValueChange}
      />
      <CheckboxList>
        {documentOptions.manufactorNames.map(name => {
          const checked = !!filter.manufacturerId?.includes(name);
          const checkId = `${name}-checkbox`;
          return (
            <CheckboxWrapper key={checkId}>
              <Checkbox
                checked={checked}
                value={name}
                onChange={onCheck}
                label={name}
              />
            </CheckboxWrapper>
          );
        })}
      </CheckboxList>
      <SourceList>
        <GroupSource as="label" htmlFor={sourceCheckId}>
          <Text text="p200">Show</Text>
          <SourceLabel
            addedBy={DocumentAddedBy.internal}
            value="Internal"
            textColor="n600"
          />
        </GroupSource>
        <Checkbox
          id={sourceCheckId}
          checked={filter.source === DocumentAddedBy.internal}
          onChange={onStatusCheck}
        />
      </SourceList>
    </StyledDiv>
  );
}
